// @flow
import * as React from 'react'
import { useRef, useEffect } from 'react'

import { useErrorStyles } from './styles'
import { useI18n } from '~/core/i18n'
import { useGlobalDispatch } from '~/core/context'

const statusCodes = ['400', '401', '403', '404', '409', '412', '500']

const resolveStatusCode = (msg, statusCode: string, replaceStatusCodes: { [key: string]: string | React.Node }) => {
  if (Object.keys(replaceStatusCodes).includes(statusCode)) {
    return replaceStatusCodes[statusCode]
  }

  if (statusCodes.includes(statusCode)) {
    return msg(`common.errors.${statusCode}`)
  }

  return msg('common.errors.unknown')
}

type ErrorProps = {
  reason: string | { statusCode: number },
  isAutoScrollable?: boolean,
  isBoilerplateUsed?: boolean,
  replaceStatusCodes?: {
    [key: string]: string | React.Node
  }
}

const Error = ({
  reason,
  isAutoScrollable,
  replaceStatusCodes = {},
  isBoilerplateUsed = true,
  ...props
}: ErrorProps) => {
  const errorWrapperRef = useRef(null)
  const globalDispatch = useGlobalDispatch()
  const classes = useErrorStyles()
  const [msg] = useI18n()

  useEffect(() => {
    if (isAutoScrollable && errorWrapperRef.current) {
      globalDispatch({
        type: 'content/scroll',
        payload: {
          top: errorWrapperRef.current.offsetTop - 100,
          behavior: 'smooth'
        }
      })
    }
  }, [])

  const ErrorNode =
    typeof reason === 'string'
      ? reason
      : resolveStatusCode(msg, String(reason?.statusCode || '500'), replaceStatusCodes)

  return reason ? (
    <div ref={errorWrapperRef} className={classes.errorWrapper} {...props}>
      {isBoilerplateUsed ? (
        <span id="error-msg">
          {msg('common.errors.prefix')} {ErrorNode}
        </span>
      ) : (
        ErrorNode
      )}
    </div>
  ) : null
}

export default Error
